import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { activeState } from "../../theme/activeState";
import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";
import { responsive } from "../../utils/responsive";

export const containerStyle = recipe({
  base: {
    position: "relative",
  },
  variants: {
    size: {
      default: {
        width: rem(36),
        height: rem(36),
        ...responsive({
          s: {
            width: rem(48),
            height: rem(48),
          },
        }),
      },
    },
    hasTitle: {
      true: {
        width: "auto",
      },
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export const iconStyle = style({
  width: rem(20),
  height: rem(20),
  ...responsive({
    s: {
      width: rem(24),
      height: rem(24),
    },
  }),
});

export const titleStyle = style({});

export const itemStyle = recipe({
  base: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--background)",
    transition: transition(
      "color",
      "outline",
      "background-color",
      "border-color",
      "border-radius",
      {
        property: "transform",
        duration: theme.transition.duration.xs,
      },
    ),
    borderRadius: "999px",
    userSelect: "none",
    position: "relative",
    selectors: {
      "&:not([disabled])": {
        cursor: "pointer",
      },
      "&:not([disabled]):active": {
        ...activeState,
      },
      "&[disabled]": {
        ...disabledState,
      },
      "&:not([disabled]):hover": {
        background: "var(--background__hover)",
      },
    },
  },
  variants: {
    variant: {
      default: {
        color: theme.colors.onBackground,
        vars: {
          "--background": "transparent",
          "--background__hover": theme.colors.background,
        },
      },
      accent: {
        color: theme.colors.onPrimary,
        vars: {
          "--background": theme.colors.primary,
          "--background__hover": theme.colors.primaryHover,
          "--background__active": theme.colors.primary,
        },
      },
    },
    active: {
      true: {
        vars: {
          "--background": "var(--background__active, var(--background__hover))",
        },
      },
    },
    hasTitle: {
      true: {
        padding: `0 ${theme.spacings.s}`,
        gap: theme.spacings.xs,
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const badgeStyle = style({
  transform: `translate(${rem(2)}, 0)`,
});
